import gsap from 'gsap';

const initPlacesFilter = (filter) => {
    const buttons = filter.querySelectorAll('.js-places-button');
    const results = document.querySelectorAll('.js-places-results');

    const handleButton = (button) => {
        if(button.classList.contains('is-active')) {
            return;
        }
        const filter = button.dataset.filter;

        buttons.forEach(button => {
            button.classList.remove('is-active');
        })

        button.classList.add('is-active');

        results.forEach(list => {
            gsap.to(list, {
                opacity: 0,
                onComplete: () => {
                    list.classList.remove('is-active');

                    if(list.dataset.filter == filter) {
                        gsap.set(list, { opacity: 0});
                        list.classList.add('is-active');
                        gsap.to(list, {
                            opacity: 1
                        })
                    }
                }
            })
        })
    }

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            handleButton(button);
        })
    })
}

export default initPlacesFilter;